import { useState, useEffect } from 'react';
import { formatSelectOptions, textareaInitialState } from '../components';

export const useDescriptionSource = ({ data, formData, objectName }) => {
  const [descriptionSources, setDescriptionSources] = useState([]);

  useEffect(() => {
    // Katalogue option should always be available
    let options = [
      {
        value: 'k',
        label: 'Katalogue',
        tooltip:
          'Set a custom description here in Katalogue.\nThis will not be updated if the description in the datasource changes,\nbut lets you take advantage of all Katalogue features for descriptions.',
      },
    ];

    // Has primary connection
    if (
      data.length > 0 && // Edit asset
      (data[0].connector_name || // And created by datasource sync task
        data[0][objectName + '_description_source'] === 'p') // Or Description source is set to primary
    ) {
      options.push({
        value: 'p',
        label: data[0].connector_name || 'Datasource',
        tooltip: `Automatically sync the description from ${data[0].connector_name || 'the datasource'}`,
        icon: data[0].connector_code,
      });
    }

    // Has secondary connection
    if (
      data.length > 0 && // Edit asset
      (data[0].secondary_connector_name || // And created by datasource sync task
        data[0][objectName + '_description_source'] === 's') // Or Description source is set to secondary
    ) {
      options.push({
        value: 's',
        label: data[0].secondary_connector_name || 'Datasource',
        tooltip: `Automatically sync the description from ${data[0].secondary_connector_name || 'the datasource'}`,
        icon: data[0].secondary_connector_code,
      });
    }

    // Adding assets manually or editing an asset without a defined description source (which is a fallback for cases when the asset was added directly by script into the database)
    if (data.length === 0 || !data[0][objectName + '_description_source']) {
      options.push({
        value: 'p',
        label: 'Datasource',
        tooltip: `Automatically sync the description from the datasource`,
      });
    }

    setDescriptionSources(options);
  }, [data]);

  const getDescription = () => {
    let description = textareaInitialState({});

    switch (formData[`${objectName}_description_source`]) {
      case 'p':
        description = formData[`${objectName}_source_description`];
        break;
      case 's':
        description = formData[`${objectName}_source_description_secondary`];
        break;
      case 'k':
        description = formData[`${objectName}_description`];
        break;
      default:
      // Nothing
    }

    return description;
  };

  const getDescriptionSourceOptions = () => {
    if (!data) {
      return;
    }

    return formatSelectOptions({
      options: descriptionSources,
      optionValue: 'value',
      optionLabel: 'label',
      optionTooltip: 'tooltip',
      optionIcon: 'icon',
    });
  };

  return {
    descriptionSources,
    getDescription,
    getDescriptionSourceOptions,
  };
};
